export default function ContactSection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 bg-foreground-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="font-label text-sm tracking-widest uppercase text-secondary-300 mb-4">Contact</p>
            <h2 className="font-heading text-3xl md:text-4xl text-background-50 leading-tight">
              Get in touch
            </h2>
            <div className="w-12 h-px bg-accent-400 mt-6"></div>
          </div>
          <div className="lg:col-span-7">
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-accent-400"></i>
                </div>
                <div>
                  <p className="font-label text-xs tracking-wider uppercase text-secondary-400 mb-1">Address</p>
                  <p className="font-body text-background-200 leading-relaxed">G Septemvriou 79</p>
                  <p className="font-body text-background-200 leading-relaxed">Athens, 10434</p>
                  <p className="font-body text-background-200 leading-relaxed">Greece</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-accent-400"></i>
                </div>
                <div>
                  <p className="font-label text-xs tracking-wider uppercase text-secondary-400 mb-1">Phone</p>
                  <p className="font-body text-background-200 leading-relaxed">+30 6988890436</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl text-accent-400"></i>
                </div>
                <div>
                  <p className="font-label text-xs tracking-wider uppercase text-secondary-400 mb-1">Email</p>
                  <p className="font-body text-background-200 leading-relaxed">dev@filoxeniaonline.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-foreground-700/40">
          <p className="font-body text-xs text-foreground-400 text-center">
            &copy; {new Date().getFullYear()} FILOXENIA.ONLINE P.C. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}